export const FREE_TEXT = "freeText";
export const SCHOOL_SEARCH = "schoolSearch";
export const ADDRESS_SEARCH = "addressSearch";
export const INTERNATIONAL_SEARCH = "internationalSearch";
export const SPECIFIED = "specified";
